import app from 'flarum/forum/app';
import MobileRegisterPage from './components/MobileRegisterPage';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import AdminLoginPage from './components/AdminLoginPage';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/forum/components/LogInModal';
import Session from 'flarum/common/Session';

// 保存登录前页面 URL 的 key
const LOGIN_RETURN_URL_KEY = 'tf-sso.loginReturnUrl';

// 跳转到登录页时保存当前页面 URL
function saveReturnUrlAndGoToLogin() {
    // 直接使用 window.location.href 避免 baseUrl + route 拼接导致路径重复
    const currentUrl = window.location.href;
    if (currentUrl && !currentUrl.includes('/mobile-register') && !currentUrl.includes('/admlogin')) {
        try {
            sessionStorage.setItem(LOGIN_RETURN_URL_KEY, currentUrl);
        } catch (e) {
            console.warn('[tf/sso] 保存登录前页面失败:', e);
        }
    }
    m.route.set(app.route('mobileRegister'));
}

app.initializers.add('tf-sso', () => {
    // 注册自定义注册页面路由 - 使用不同的路由名称避免冲突
    app.routes.mobileRegister = {
        path: '/mobile-register',
        component: MobileRegisterPage
    };
    //注册admin登录页面
    app.routes.adminLogin = {
        path: '/admlogin',
        component: AdminLoginPage
    };

    // 注册条款页面
    app.routes.terms = {
        path: '/terms',
        component: TermsPage
    };

    // 注册隐私政策页面
    app.routes.privacy = {
        path: '/privacy',
        component: PrivacyPage
    };
 
    // 动态获取当前路由信息
    const currentRouteInfo = window.location.href.includes('adminLogin');
    const currentIsAdminLogin = currentRouteInfo;
    // 扩展HeaderSecondary组件，修改登录按钮的点击事件
    try {
        extend(HeaderSecondary.prototype, 'items', function (items) {
            // 移除原有的登录按钮
            items.remove('signUp');
            
            if (!app.session.user && !currentIsAdminLogin) {
                items.remove('logIn');
                // 添加自定义登录按钮
                items.add(
                    'logIn',
                    <Button 
                        className="Button Button--link" 
                        onclick={() => {
                            // 保存当前页面 URL，登录成功后跳回
                            saveReturnUrlAndGoToLogin();
                        }}
                    >
                        {app.translator.trans('core.forum.header.log_in_link')}
                    </Button>,
                    0
                );
               
            }
        });
    } catch (error) {
        console.error('[tf/sso] 扩展HeaderSecondary失败:', error);
    }

    // 拦截 LogInModal 的显示，重定向到自定义登录页面
    try {
       

        // 拦截模态框管理器的 show 方法
        if (app.modal && app.modal.show&&!currentIsAdminLogin) {
            const originalModalShow = app.modal.show;
            app.modal.show = function(component, attrs) {
                // 如果是要显示 LogInModal，则保存当前页面并重定向到登录页
                if (component === LogInModal) {
                    saveReturnUrlAndGoToLogin();
                    return;
                }
                
                // 其他模态框正常显示
                return originalModalShow.call(this, component, attrs);
            };
        }
    } catch (error) {
        console.error('[tf/sso] 扩展LogInModal失败:', error);
    }

    // 扩展 Session 的 logout 方法，在退出登录前调用 SSO 远程登出接口
    try {
        // 保存原始的 logout 方法（从原型和实例两个层面）
        const originalLogoutPrototype = Session.prototype.logout;
        
        // 覆盖原型方法，这样所有 Session 实例都会使用新方法
        Session.prototype.logout = function () {
            // 如果用户已登录，先调用 SSO 远程登出接口
            if (this.user) {
                const apiUrl = app.forum.attribute('apiUrl');
                const logoutUrl = apiUrl + '/sso/remote-logout';
                
                // 构建完整的 URL
                const fullUrl = logoutUrl.startsWith('http') 
                    ? logoutUrl 
                    : window.location.origin + logoutUrl;
                let that = this
                    fetch(fullUrl, {
                        method: 'POST',
                        keepalive: true,
                        credentials: 'include'
                    }).then(response => {
                        if (response.ok) {
                            // console.log('[tf/sso] SSO 远程登出请求成功');
                            return originalLogoutPrototype.call(that);
                        } else {
                            console.warn('[tf/sso] SSO 远程登出请求返回非成功状态:', response.status);
                        }
                    }).catch(err => {
                        console.error('[tf/sso] SSO 远程登出失败:', err);
                    });    
                
                // 使用 navigator.sendBeacon 确保请求在页面卸载前发送
                // sendBeacon 是专门为页面卸载时发送请求设计的
               
            }
            
            // 调用原有的 logout 方法（会立即跳转页面）
            
        };
        
        console.log('[tf/sso] Session.logout 方法已扩展');
    } catch (error) {
        console.error('[tf/sso] 扩展Session.logout失败:', error);
    }

    // 会话过期（401）：拦截 API 请求错误，调用远程登出并跳转登录页
    try {
        const originalRequestErrorCatch = app.requestErrorCatch.bind(app);
        app.requestErrorCatch = function (error, customErrorHandler) {
            if (error && error.status === 401 && app.session.user) {
                // const apiUrl = app.forum.attribute('apiUrl');
                // const fullUrl = (apiUrl.startsWith('http') ? apiUrl : window.location.origin + apiUrl) + '/sso/remote-logout';
                // fetch(fullUrl, { method: 'POST', credentials: 'include' })
                //     .catch(err => console.warn('[tf/sso] 会话过期时远程登出请求失败:', err))
                //     .finally(() => {
                //         const baseUrl = app.forum.attribute('baseUrl') || '';
                //         
                //     });
                // 保存当前页面 URL，登录成功后跳回
                try {
                    const currentUrl = window.location.href;
                    if (!currentUrl.includes('/mobile-register') && !currentUrl.includes('/admlogin')) {
                        sessionStorage.setItem(LOGIN_RETURN_URL_KEY, currentUrl);
                    }
                } catch (e) {
                    console.warn('[tf/sso] 保存登录前页面失败:', e);
                }
                const baseUrl = app.forum.attribute('baseUrl') || '';
                const loginPath = (baseUrl.replace(/\/$/, '') + '/mobile-register');
                window.location.href = loginPath.startsWith('http') ? loginPath : (window.location.origin + loginPath);

                return Promise.reject(error);
            }
            return originalRequestErrorCatch(error, customErrorHandler);
        };
    } catch (error) {
        console.error('[tf/sso] 扩展 requestErrorCatch 失败:', error);
    }

});
